<template>
  <section class="form-section">
    <div class="flex row" v-if="isShowList">
      <div class="title-page-form">Solicitações</div>
      <div class="div-requests col-12 row flex">
        <CardSolicitationOs
          v-for="item in contract.solicitations"
          :check="schemeSolicitation.isFilled"
          :os-number="item.osNumber"
          :type-os="item.typeOS"
          :key="item.onject_id"
          :title="`Códigos Especiais - ${typeOs.name_type}`.toLocaleUpperCase()"
          @edit="(item) => handleShowEditSolicitation()"
          @removeCard="() => deleteSchemaRequest(item.object_id)"
        />
      </div>
    </div>
    <SolicitationForm
      v-else
      :itemOsContract="schemeSolicitation"
      :city="contract.city"
      :listTypeOS="[]"
      :optionsItens="optionsItens"
      :typeOs="typeOs.os_type"
      @clearSchemaRequest="() => {}"
      @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)"
      @removeEdit="() => showEditSolicitation()"
    />
  </section>
</template>

<script>
import CardSolicitationOs from "@/components/cards/CardSolicitationOs.vue";
import { onMounted, ref } from "vue";

import generateUUIDv4 from "@/utils/generetaUUID.js";
import SolicitationForm from "./Forms/SolicitationForm.vue";

export default {
  name: "SolicitationList",
  props: {
    contract: Object,
    optionsItens: Object,
    typeOs: Object,
  },
  components: {
    SolicitationForm,
    CardSolicitationOs,
  },
  emits: ["disabledtabButton"],

  setup(props, { emit }) {
    let schemeSolicitation = {
      object_id: generateUUIDv4(),
      osNumber: "",
      typeOS: null,
      writeOffCode: null,
      observation: "",
      isFilled: false,
    };
    let isShowList = ref(true);

    function addNewSolicitation() {
      props.contract.solicitations.push(schemeSolicitation);
    }

    function deleteSchemaRequest(object_id) {
      let newObjectOSRequest = props.contract.solicitations.filter((obj) => {
        return obj.object_id != object_id;
      });

      props.contract.solicitations = newObjectOSRequest;
    }

    function handleShowEditSolicitation() {
      emit("disabledtabButton", false);
      isShowList.value = false;
    }

    function showEditSolicitation() {
      emit("disabledtabButton", true);
      isShowList.value = true;
    }

    function saveSchemaRequest(value) {
      emit("disabledtabButton", true);
      isShowList.value = true;
      schemeSolicitation.isFilled = true;
    }

    async function validateForm() {
      return true;
    }

    onMounted(() => {
      addNewSolicitation();
    });

    return {
      schemeSolicitation,
      isShowList,
      addNewSolicitation,
      deleteSchemaRequest,
      handleShowEditSolicitation,
      showEditSolicitation,
      saveSchemaRequest,
      validateForm,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-section {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>